import * as React from "react";
import { useEffect, useState } from "react";
import { Box, Button, Typography, Grid2, LinearProgress } from "@mui/material";
import { useLocation } from "react-router-dom";
import SignUpBg from "../../../Assets/Images/Signup_web.png";
import {useSelector, useDispatch } from 'react-redux';
import { faceMatchApi, liveness, setDummyUser,SeflieandSignatureStatus } from "../../../Redux/usersSlice";
import icon from "../../../Assets/Images/icon.svg"
import success from "../../../Assets/Images/bvsuccess.svg"
import CaptureStyles1 from "./capturePhotoStyle.module.css";
import SignatureStyles from "../Signature/Signature.module.css"
import Webcam from "react-webcam";
import { publicIpv4 } from 'public-ip';
import CryptoJS from "crypto-js";
const webcamRef = React.createRef(null);

export default function CaptureSelfieMobile() {

    const dispatch = useDispatch();
    // const {panData,faceMatch} = useSelector( state => state.user);
    // console.log("pan",panData?.facematch,faceMatch)
   
    // dispatch(setDummyUser())

    const [capturedImage, setCapturedImage] = useState(null);
    const [matchScore, setMatchScore] = useState(0)
    const [livelinessScore, setLivelinessScore] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [passed, setPassed] = useState(false)
    const [isCompleted, setIsCompleted] = useState(false)

    const [backend, setBackend] = useState(false);
    const [facematch, setFacematch] = useState(false);
    const location = useLocation();

    const [user, setUser] = useState({
        mobile: "",
        email: "",
        user_id: ""
    })

    const handleReset = () => {
        setIsCompleted(true)
        setCapturedImage(null)
        setPassed(false)
        setLivelinessScore(0)
        setMatchScore(0)
    }

    const params = new URLSearchParams(window.location.search)
    
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "selfie_qr_page_viewed",
            page_path: window.location.pathname
        });
        if (params.get("data")) {
            const bytes = CryptoJS.AES.decrypt(params.get("data")?.split(" ")?.join("+"), "96358214256984120");
            const decryptedText = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            console.log(decryptedText, "decoded data");
            setUser({ ...decryptedText })
        }
    }, [])

    // useEffect(() => {
    //     const params = new URLSearchParams(location.search);

    //     setBackend(params.get("backend") ==="true");
    //     setFacematch(params.get("facematch") ==="true");

    // }, [location.search]);

    // console.log("backend,facematch",backend,facematch)

    
    useEffect(()=>{
        if(user?.user_id){
            (async ()=>{
                try{
                    const signatureStatus = await dispatch(SeflieandSignatureStatus({mobile : user?.mobile,email : user?.email,type : "selfie"})).unwrap();
                    if(signatureStatus?.data?.data?.status){
                      setIsCompleted(true)
                    }
                }catch(e){
                    console.log(e)
                }
        
            })()
        }
    },[user])

    // const handleCapture = async () => {

    //     console.log("handleCapture")
    //     setError(false)
    //     setErrorMessage("")
    //     if (capturedImage) {
    //         setCapturedImage(false)
    //         setIsLoading(false)
    //         return
    //     }
    //     setIsLoading(true)
    //     setLivelinessScore(0)
    //     setMatchScore(0)
    //     setPassed(false)

    //     const { email, mobile } = user

    //     const imageSrc = webcamRef.current.getScreenshot({ width: 972, height: 1296, dpi: 96 });
    //     console.log("imageSrc",imageSrc)
    //     if (imageSrc) {
    //         setCapturedImage(imageSrc);
    //         console.log("imageSrc in")

    //         // try {
    //         //     const faceVerify = await dispatch(faceMatchApi({ mobile, email, selfieImage: imageSrc })).unwrap()
    //         //     const data = faceVerify?.data?.data

    //         //     if (data?.success == true) {
    //         //         setMatchScore(data?.similarity)
    //         //         const ip = await publicIpv4()
    //         //         const livenessVerify = await dispatch(liveness({ mobile, email, selfieImage: imageSrc, ip: ip })).unwrap()
    //         //         const livenessResult = livenessVerify?.data?.data

    //         //         if (livenessResult?.success) {
    //         //             setLivelinessScore(livenessResult?.score)
    //         //             setPassed(true)
    //         //         } else {
    //         //             setError(true)
    //         //             setErrorMessage(livenessResult?.message)
    //         //         }
    //         //         setIsLoading(false)
    //         //     } else {
    //         //         setError(true)
    //         //         setErrorMessage(data.message)
    //         //     }

    //         //     setIsLoading(false)
    //         // }
    //       try{   
    //           if (backend || facematch){
    //                  console.log("innn")
    //                const faceVerify = await dispatch(faceMatchApi({ mobile, email, selfieImage: imageSrc })).unwrap()
    //                console.log(faceVerify?.data?.data, "face")
    //                const data = faceVerify?.data?.data
    //                console.log(data, data?.success, "success")
    //                if (data?.success == true) {
    //                    console.log("in1" )
    //                  setMatchScore(data?.similarity)
    //                  const ip = await publicIpv4()
    //                  console.log("backend",{ mobile, email, selfieImage: imageSrc, ip: ip,facematch:backend})
    //                  const livenessVerify = await dispatch(liveness({ mobile, email, selfieImage: imageSrc, ip: ip,facematch:backend})).unwrap()
    //                  const livenessResult = livenessVerify?.data?.data
    //                  console.log(livenessResult,livenessVerify?.data,livenessVerify, "livenessResult111")
    //                  console.log(livenessResult, "livenessResult")
    //                  alert(JSON.stringify(livenessVerify?.data?.data))
    //                  console.log(livenessResult, "livenessResult")
    //                  if (livenessResult?.success) {
    //                    console.log(livenessResult?.score, "livenessResult")
    //                    setLivelinessScore(livenessResult?.score)
    //                    setPassed(true)
    //                  } else {
    //                      console.log("Liveness error")
    //                    setError(true)
    //                    setErrorMessage(livenessResult?.message)
    //                  }
    //                  setIsLoading(false)
    //                } else {
    //                  setError(true)
    //                  setErrorMessage(data.message)
    //                }
    //              }else{
    //                  console.log("else")
    //                    const ip = await publicIpv4()
    //                  console.log("ip")
    //               const livenessVerify = await dispatch(liveness({ mobile, email, selfieImage: imageSrc, ip: ip, facematch: backend })).unwrap()
    //               const livenessResult = livenessVerify?.data?.data
    //             //   alert(JSON.stringify(livenessVerify?.data?.data))
    //               console.log(livenessResult,livenessVerify?.data,livenessVerify, "livenessResult111")
    //               console.log(livenessResult, "livenessResult")
    //                    if(livenessResult?.success){
    //                      console.log(livenessResult?.score, "livenessResult")
    //                      setLivelinessScore(livenessResult?.score)
    //                      setPassed(true)
    //                      setIsLoading(false)
    //                    }else{
    //                      setError(true)
    //                      setErrorMessage(livenessResult?.message)
    //                  }
         
    //              }
                 
    //              setIsLoading(false)
    //            }
    //          catch (error) {
    //             setError(true)
    //             setIsLoading(false)
    //             setErrorMessage(error?.data?.data?.message)
    //         }

    //     }
    // }

    // const handleCapture = async () => {
    //     setError(false);
    //     setErrorMessage("");
    //     if (capturedImage) {
    //         setCapturedImage(false);
    //         setIsLoading(false);
    //         return;
    //     }
    //     setIsLoading(true);
    //     // Remove setMatchScore(0) but keep liveness score reset
    //     setLivelinessScore(0);
    //     setPassed(false);

    //     const { email, mobile } = user;

    //     const imageSrc = webcamRef.current.getScreenshot({ width: 972, height: 1296, dpi: 96 });
    //     if (imageSrc) {
    //         setCapturedImage(imageSrc);

    //         try {
    //             // REMOVE THE FACE MATCH CALL ENTIRELY
    //             // const faceVerify = await dispatch(faceMatch({ mobile, email, selfieImage: imageSrc })).unwrap()

    //             // Proceed directly to liveness check
    //             const ip = await publicIpv4();
    //             const livenessVerify = await dispatch(liveness({ mobile, email, selfieImage: imageSrc, ip: ip })).unwrap();
    //             const livenessResult = livenessVerify?.data?.data;

    //             if (livenessResult?.success) {
    //                 setLivelinessScore(livenessResult?.score);
    //                 setPassed(true);
    //             } else {
    //                 setError(true);
    //                 setErrorMessage(livenessResult?.message);
    //             }
    //             setIsLoading(false);
    //         } catch (error) {
    //             setError(true);
    //             setIsLoading(false);
    //             setErrorMessage(error?.data?.data?.message);
    //         }
    //     }
    // };



//      const handleCapture = async () => {
//         setError(false)
//         setErrorMessage("")
//         if (capturedImage) {
//             setCapturedImage(false)
//             setIsLoading(false)
//             return
//         }
//         setIsLoading(true)
//         setLivelinessScore(0)
//         setMatchScore(0)
//         setPassed(false)

//         const { email, mobile } = user

//         const imageSrc = webcamRef.current.getScreenshot({ width: 972, height: 1296, dpi: 96 });
//         if (imageSrc) {
//             setCapturedImage(imageSrc);

//           try {
//     // Step 1: Face match
//     const faceVerify = await dispatch(
//         faceMatchApi({ mobile, email, selfieImage: imageSrc })
//     ).unwrap();

//     const data = faceVerify?.data?.data;
//     console.log("Face match response:", data);

//     if (!data?.success) {
//         setError(true);
//         setErrorMessage(data?.message || "Face match failed");
//         return;
//     }

//     setMatchScore(data?.similarity);

//     // Step 2: Liveness
//     console.log("Calling liveness API...");
//     const ip = await publicIpv4();
//     const livenessVerify = await dispatch(
//         liveness({ mobile, email, selfieImage: imageSrc, ip })
//     ).unwrap();

//     console.log("Raw livenessVerify response:", livenessVerify);

//     const livenessResult = livenessVerify?.data?.data;
//     console.log("🎯Parsed livenessResult:", livenessResult);

//     if (livenessResult?.success) {
//         setLivelinessScore(livenessResult?.score);
//         setPassed(true);
//     } else {
//         setError(true);
//         setErrorMessage(livenessResult?.message || "Liveness failed");
//     }

// } catch (error) {
//     console.error("❌ handleCapture catch error:", error);
//     setError(true);
//     setErrorMessage(error?.data?.data?.message || "Something went wrong");
// } finally {
//     setIsLoading(false);
// }


//         }
//     }

const handleCapture = async () => {
    
        console.log("LOG 1", "handle Capture")
        setError(false)
        setErrorMessage("")
        if (capturedImage) {
            setCapturedImage(false)
            setIsLoading(false)
            return
        }
        setIsLoading(true)
        setLivelinessScore(0)
        setMatchScore(0)
        setPassed(false)

        const { email, mobile } = user
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "selfie_qr_captured",
            page_path: window.location.pathname
        });
        const imageSrc = webcamRef.current.getScreenshot({ width: 972, height: 1296, dpi: 96 });
        console.log("LOG 2", imageSrc == true)
        if (imageSrc) {
            setCapturedImage(imageSrc);
            console.log("LOG 3", "inside imageSRc if condition")
            try {
                const faceVerify = await dispatch(faceMatchApi({ mobile, email, selfieImage: imageSrc,device:"QR" })).unwrap()
                const data = faceVerify?.data?.data
                console.log("LOG 4", JSON.stringify(data))
                if (data?.success == true) {
                    console.log("LOG 5", JSON.stringify(data) , "if face match is success")
                    setMatchScore(data?.similarity)
                    const ip = await publicIpv4()
                    const livenessVerify = await dispatch(liveness({ mobile, email, selfieImage: imageSrc, ip: ip, device: "QR" })).unwrap()
                    const livenessResult = livenessVerify?.data?.data

                    if (livenessResult?.success) {
                        setLivelinessScore(livenessResult?.score)
                        setPassed(true)
                    } else {
                        setError(true)
                        setErrorMessage(livenessResult?.message)
                    }
                    setIsLoading(false)
                } else {
                    console.log("LOG 6", JSON.stringify(data) , "if face match is not success")
                    setError(true)
                    setErrorMessage(data.message)
                }

                setIsLoading(false)
            } catch (error) {
                console.log("LOG 7", JSON.stringify(error) , "Catch Block")
                setError(true)
                setIsLoading(false)
                setErrorMessage(error?.data?.data?.message)
            }

        }
    }

console.log("livenessResultOut",livelinessScore)
    return (
        <main>
        <Box sx={{
            display: "flex",
            minHeight: "100vh !important",
            backgroundImage: `url(${SignUpBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
        }}>
            {isCompleted &&
                <Box className={SignatureStyles.content_wrapper}>
                    <Grid2 flexDirection="column" display="flex" justifyContent="center" alignItems="center" height="600px" width="100%">
                        <img src={success} alt="successLogo" />
                        <Typography className={SignatureStyles.title} sx={{ padding: "0px 30px" }}>Your selfie has been captured successfully</Typography>
                        <Button sx={{ marginTop: "30px" }} onClick={() => {
                        setIsCompleted(false)
                        setCapturedImage(null)
                        setPassed(false)
                    }} className={SignatureStyles.skip_button}>
                        Edit
                    </Button>
                    </Grid2>
                </Box>
            }

            {/* Your content area */}
            {!isCompleted && <Box
                sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    // justifyContent: "center",
                }}
            >
                <Typography
                    sx={{
                        color: "#481B9D",
                        fontSize: "48px",
                        fontFamily: "Inter900",
                        paddingTop: "70px",
                        marginBottom: "10px",
                        padding: "20px",
                        textAlign: "center",
                        "@media screen and (max-width : 600px)": {
                            fontSize: "30px !important",
                        }
                    }}
                    className={CaptureStyles1.heading}
                >
                    Stay still and Capture now
                </Typography>
                <Grid2>
                    <div
                        style={{
                            width: "267px",
                            height: "273px",
                            border: "8px solid #1CF400",
                            borderRadius: "50%",
                            overflow: "hidden",
                            position: "relative",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        {capturedImage ? (
                            <img
                                src={capturedImage}
                                alt="Captured"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                }}
                            />
                        ) : (
                            <Webcam
                                audio={false}
                                ref={webcamRef}
                                screenshotFormat="image/jpeg"
                                screenshotQuality={1}
                                mirrored={true}
                                videoConstraints={{
                                    facingMode: "user", // front camera for selfie
                                }}
                                style={{
                                    objectFit: "cover",
                                    width: "100%",
                                    height: "100%",
                                }}
                            />
                        )}
                    </div>
                </Grid2>
                {capturedImage && <Grid2 sx={{ display: 'flex', justifyContent: "space-between", alignItems: "center", width: "300px", marginTop: "20px" }}>
                    {isLoading ? <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box> :
                        <>
                            {/* <Typography>Face Match - {matchScore?.toFixed(2)}%</Typography> */}
                             <Typography>
                                Face Match - {matchScore > 0 ? `${matchScore.toFixed(2)}%` : "NA"} {/* if NA , Face match is skiped */}
                                </Typography>
                            <Typography sx={{ marginLeft:"5px"}} >liveness - {livelinessScore?.toFixed(2)}%</Typography></>}
                </Grid2>}
                {/* {capturedImage && <Grid2 sx={{ display: 'flex', justifyContent: "center", alignItems: "center", width: "300px", marginTop: "20px" }}>
                    {isLoading ? <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box> :
                        <Typography>Liveness - {livelinessScore?.toFixed(2)}%</Typography>}
                </Grid2>} */}

                {error && <Grid2 sx={{ display: 'flex', justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                    <Typography sx={{ color: "red", textAlign: "center" }}>{errorMessage}</Typography>
                </Grid2>}
                {passed && <Grid2 sx={{ display: 'flex', justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                    <Typography sx={{ color: "green" }}>Face Match Success</Typography>
                </Grid2>}
                {/* {passed && <Grid2 sx={{ display: 'flex', justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                    <Typography sx={{ color: "green" }}>Liveness Check Passed</Typography>
                </Grid2>} */}
                <Grid2 className={CaptureStyles1.but_card}>
                    <Grid2>
                        {!passed && <Button
                            disabled={isLoading}
                            className={CaptureStyles1.con_button}
                            onClick={handleCapture}
                        >
                            {capturedImage ? "Retake" : "Capture Photo"}
                        </Button>}
                        {passed && <Button
                            disabled={isLoading}
                            className={CaptureStyles1.con_button}
                            onClick={handleReset}
                        >
                            continue
                        </Button>}
                        {passed && <Typography className={SignatureStyles.txt} mt="20px" >
                                          <span style={{ textDecoration: "underline", color: "blue", cursor: "pointer" , fontSize : "16px" }} onClick={() =>{
                                            setIsCompleted(false)
                                            setCapturedImage(null)
                                            setPassed(false)
                                          } }>Take Selfie again</span>
                                        </Typography>}
                    </Grid2>

                </Grid2>
                <Typography className={CaptureStyles1.footerText}>
                    Please allow LOCATION and CAMERA permissions when requested. You
                    need to do this only ONCE as per SEBI regulations, to open a Demat
                    account.
                </Typography>

                <Box className={CaptureStyles1.card}>
                    <img
                        src={icon} // Replace with your image URL
                        alt="Checkmark"
                        className={CaptureStyles1.icon}
                    />
                    <Typography className={CaptureStyles1.txt}>
                        Your account details are safe & secure with us.
                    </Typography>
                </Box>
            </Box>}
        </Box>
        </main>
    );
}


